var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "12 10 6 10.001"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.537 10.15a.465.465 0 0 0-.683 0l-.684.716a.52.52 0 0 0 0 .715l3.295 3.405-3.322 3.434a.52.52 0 0 0 0 .716l.683.716a.47.47 0 0 0 .684 0l4.349-4.507a.526.526 0 0 0 0-.717z"
})));
export default SvgCaretRight;